import type { AuthenticationRepository } from "@authentication/domain/repositories/authentication.repository";
import { authenticationTypes } from "@authentication/root/authentication-types.di";
import { ToastManagerRepository } from "@iot-platform/core";
import { inject, injectable } from "inversify";

@injectable()
export class AuthenticationRequestMailToResetPasswordUseCase {
    constructor(
        @inject(authenticationTypes.repositories.AuthenticationRepository)
        private readonly authenticationRepository: AuthenticationRepository,
    ) {}

    async execute(email: string): Promise<boolean> {
        const result =
            await this.authenticationRepository.requestMailToResetPassword(
                email,
            );

        if (result.isErr()) {
            ToastManagerRepository.error(result.error.message);
            return false;
        }

        return true;
    }
}
